"use client";

import { signIn } from "next-auth/react";
import { Button } from "@/components/shadcn/button";

export function AuthActions() {
  const familySignIn = (options?: Record<string, string>) =>
    signIn("keycloak", { callbackUrl: "/api/auth/post-signin" }, { ...options });
  const familyRegister = () =>
    signIn("keycloak", { callbackUrl: "/api/auth/post-signin" }, { prompt: "create" });

  return (
    <div className="flex items-center gap-1.5 sm:gap-4">
      <Button
        size="sm"
        className="px-3 text-xs sm:px-10 sm:text-sm bg-gradient-to-r from-emerald-600 to-teal-600 font-semibold shadow-xl shadow-emerald-500/30 transition-all hover:shadow-2xl hover:shadow-emerald-500/40"
        onClick={() => familySignIn()}
      >
        Login
      </Button>
      <Button
        size="sm"
        variant="outline"
        className="px-3 text-xs sm:px-6 sm:text-sm font-medium"
        onClick={familyRegister}
      >
        Register
      </Button>
    </div>
  );
}